export default __webpack_public_path__ + "static/underline-25-7e3a7e7623066f10f1b32a12ab3302c8.svg";